/* ===== Page Routing ===== */
import { $ } from '../utils/helpers.js?v=82.86';
import { applyClientUI, handleCampaignStatusChange } from './slideshow.js?v=82.86';
import { updateTriesCounter } from './admin.js?v=82.86';
import { stopSlideshow } from './slideshow.js?v=82.86';
import { resetRegisterForm } from './forms.js?v=82.86';
import { getCurrentUser } from '../services/auth.js?v=82.86';
import { loadSettings, getCurrentSettings } from '../services/settings.js?v=82.86';
import { getPublicClientSlug, parsePublicSlugFromPath } from '../services/public-client.js?v=82.86';

function isPublicQrContext() {
  return !!(getPublicClientSlug() || parsePublicSlugFromPath());
}
import { logger } from '../utils/logger.js?v=82.86';
import { applyCommunityUI } from '../services/community.js?v=82.86';

/** Pe /m/{slug} clientul nu poate deschide admin, cont, login etc. */
const PUBLIC_QR_ALLOWED_PAGES = new Set(['clientPage', 'communityPage', 'claimPage', 'publicJoinErrorPage']);

/** Pagini comerciant care cer billing activ (demo/abonament, non-blocat) */
const MERCHANT_BILLING_GUARDED_PAGES = new Set([
  'adminPage',
  'joyAssistantPage',
  'clientPage',
  'accountPage',
  'rolePage'
]);

export async function showPage(id) {
  document.getElementById('sjBootSplash')?.remove();
  if (isPublicQrContext() && !PUBLIC_QR_ALLOWED_PAGES.has(id)) {
    logger.warn('[routing] Pagină blocată în mod public QR:', id);
    id = 'clientPage';
  }

  if (id === 'superadminPage' && !isPublicQrContext()) {
    const u = getCurrentUser();
    if (!u) {
      id = 'loginPage';
    } else {
      try {
        const t = await u.getIdTokenResult();
        if (!t.claims || t.claims.superadmin !== true) {
          id = 'adminPage';
        }
      } catch (_) {
        id = 'loginPage';
      }
    }
  }

  if (MERCHANT_BILLING_GUARDED_PAGES.has(id) && !isPublicQrContext()) {
    try {
      const [{ getMerchantAccessCached }, { withTimeoutMs }] = await Promise.all([
        import('../services/merchant-access.js?v=82.86'),
        import('../utils/with-timeout.js?v=82.86')
      ]);
      const r = await withTimeoutMs(getMerchantAccessCached(getCurrentUser()?.uid), 12000);
      if (!r.isSuperadmin && !r.allowed) {
        const msgEl = document.getElementById('accountBillingLockedMessage');
        if (msgEl) {
          msgEl.textContent =
            r.message ||
            'Perioada demo a expirat. Pentru continuare, achită abonamentul și așteaptă activarea contului.';
        }
        id = 'accountBillingLockedPage';
      }
    } catch (e) {
      // Blocarea se face DOAR când serverul răspunde explicit „allowed: false”. O eroare de transport (telefon
      // offline, rețea slabă, funcția indisponibilă) nu înseamnă cont suspendat: înainte, aplicația arăta pagina
      // „Acces suspendat” cu mesajul tehnic „internal” de fiecare dată când comerciantul deschidea aplicația fără net.
      // Serverul își impune oricum suspendarea la orice scriere (throwIfMerchantAppSuspended).
      logger.warn('[routing] Billing check failed (' + (e?.code || e?.message || 'eroare') + ') — allowing navigation');
    }
  }

  document.querySelectorAll('.page').forEach(p => p.classList.remove('visible'));
  const page = $(id);
  if (page) page.classList.add('visible');
  document.body.classList.toggle('sj-claim-flow-active', id === 'claimPage');
  window.scrollTo(0, 1);

  const langToggle = $('langToggle');
  if (langToggle) {
    const isPublicQr = isPublicQrContext();
    const hideLang =
      id !== 'loginPage' ||
      isPublicQr ||
      id === 'superadminPage' ||
      id === 'accountBillingLockedPage';
    langToggle.classList.toggle('hidden', hideLang);
  }

  if (id === 'clientPage' || id === 'communityPage') {
    if (window.closeLocationMenuMode) window.closeLocationMenuMode();
    applyClientUI();
    if (id === 'clientPage') {
      updateTriesCounter();
      const pb = $('playBtn');
      if (pb) pb.style.display = '';
    } else {
      applyCommunityUI();
    }
    
    // ✅ REMOVED: Listener is started once on login, not per page
    // Listener is already active from app-new.js initAuth callback
  } else {
    if (window.closeLocationMenuMode) window.closeLocationMenuMode();
    // Joy Assistant își gestionează singur fundalul (preview client)
    if (id !== 'joyAssistantPage') {
      stopSlideshow();
    }
    if (typeof window !== 'undefined' && window.__aiLayoutPreviewActive === true) {
      import('../services/admin.js?v=82.86')
        .then((m) => m.exitAiLayoutPreview?.())
        .catch(() => {});
    }
    
    // ✅ REMOVED: Don't stop listener when leaving pages - keep it active until logout
    // stopClientSettingsListener(); // ❌ REMOVED
  }
  
  if (id === 'joyAssistantPage') {
    setTimeout(() => {
      import('./joy-assistant.js?v=82.86')
        .then((m) => m.initJoyAssistantPage?.())
        .catch(() => {});
    }, 50);
  }

  if (id === 'adminPage') {
    // Check if admin password is set before allowing access
    const currentUser = getCurrentUser();
    if (currentUser) {
      // ✅ FIX: Dacă ești offline, NU force reload (păstrează setările locale)
      // Plasă de siguranță pornită ÎNAINTE de încărcare: adminul nu poate rămâne o pagină goală.
      setTimeout(() => {
        const ap = document.getElementById('adminPage');
        if (ap && !ap.classList.contains('sja-on')) ap.classList.remove('sja-pending');
      }, 8000);
      // Setările tocmai au fost încărcate la logare → nu le mai cerem a doua oară (force=false folosește cache-ul recent).
      let settingsOk = true;
      try {
        const { withTimeoutMs } = await import('../utils/with-timeout.js?v=82.86');
        await withTimeoutMs(loadSettings(currentUser.uid, false), 15000);
      } catch (e) {
        settingsOk = false;
        console.warn('[routing] loadSettings slow/failed', e);
      }
      const currentSettings = getCurrentSettings();
      const savedHash = String(currentSettings?.adminPassHash || '').trim();
      
      // PIN-ul nu mai e folosit: Modul client deschide pagina publică (/m/slug).
      // Pagina încă goală → „Hai să creăm pagina” cu Joy.
      void savedHash;
      if (settingsOk) {
        setTimeout(() => {
          import('./welcome-joy.js?v=82.86').then((m) => m.maybeShowWelcomeJoy()).catch(() => {});
        }, 600);
        // Conturi fără adresă publică → o creăm automat (o singură dată, în fundal)
        if (!String(currentSettings?.publicSlug || '').trim()) {
          import('../services/backend.js?v=82.86')
            .then((m) => m.ensurePublicSlugBackend())
            .then((r) => { const cs = getCurrentSettings(); if (r && r.slug && cs) cs.publicSlug = r.slug; })
            .catch(() => {});
        }
      }
      
      // Update admin page brand with company name
      setTimeout(() => {
        import('./account.js?v=82.86').then(module => {
          module.updateAdminPageBrand();
        }).catch(() => {});
      }, 100);
    }
    
    if (window.refreshClaims) window.refreshClaims();
    // Navigarea nouă (Acasă · Pagina · Joy · Clienți · Cont)
    import('./admin-shell.js?v=82.86')
      .then((m) => m.mountAdminShell())
      .catch((e) => {
        console.warn('[admin-shell]', e);
        document.getElementById('adminPage')?.classList.remove('sja-pending');
      });
    // Plasă de siguranță: dacă adminul nou nu apare în 8s, arătăm ce există.
    setTimeout(() => {
      const ap = document.getElementById('adminPage');
      if (ap && !ap.classList.contains('sja-on')) ap.classList.remove('sja-pending');
    }, 8000);
    // Initialize collapsible sections
    setTimeout(() => {
      if (window.initAdminSections) {
        import('./admin-collapsible.js?v=82.86').then(module => {
          module.initAdminSections();
        }).catch(() => {});
      }
    }, 100);
  }
  
  if (id === 'registerPage') {
    resetRegisterForm();
    ['regPassword2', 'regLocName', 'regLocCity'].forEach((x) => { const n = document.getElementById(x); if (n) n.value = ''; });
    import('./auth-pages.js?v=82.86').then((m) => m.onRegisterShown()).catch(() => {});
  }
  
  if (id === 'claimPage') {
    // Resetează butonul "Trimite" când se deschide formularul
    const submitBtn = $('submitClaimBtn');
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.style.pointerEvents = '';
      submitBtn.classList.remove('btn-disabled-state');
      submitBtn.textContent = 'Trimite';
    }
    
    // Resetează flag-ul isSubmittingClaim + responsabili + câmp număr bon
    try {
      const module = await import('../services/claims.js?v=82.86');
      if (module.resetClaimFormState) module.resetClaimFormState();
      if (module.initClaimResponsibleSelector) await module.initClaimResponsibleSelector();
    } catch (_) {
      /* ignore */
    }
  }
  
  if (id === 'rolePage') {
    // Update role cards when role page is shown
    setTimeout(() => {
      import('./role-selection.js?v=82.86').then(module => {
        module.updateRoleCards();
      }).catch(() => {});
    }, 100);
  }
  
  if (id === 'accountPage') {
    import('./admin-shell.js?v=82.86')
      .then((m) => m.mountAccountNav())
      .catch(() => {});
    // Load account settings when account page is shown
    setTimeout(() => {
      import('./account.js?v=82.86').then(module => {
        module.loadAccountSettings();
        module.initAccountSections();
      }).catch(() => {});
    }, 100);
  }
  
  // Apply local background for accountPage and adminPage (from localStorage)
  // DOAR local, fără Firebase pentru adminPage
  if (id === 'adminPage' || id === 'accountPage') {
    import('../utils/helpers.js?v=82.86').then(m => m.applyLocalBackground()).catch(() => {});
  }
}

// Make available globally for onclick handlers
window.showPage = showPage;
